import type { Network } from '@aptos-labs/ts-sdk';
import { Aptos, AptosConfig } from '@aptos-labs/ts-sdk';
import type { NetworkData } from '@dynamic-labs-sdk/client';

import { OCTAS_PER_APT } from '../constants';

type FetchAptosBalanceParams = {
  address: string;
  networkData: NetworkData;
};

export const fetchAptosBalance = async ({
  address,
  networkData,
}: FetchAptosBalanceParams): Promise<string | null> => {
  const config = new AptosConfig({
    fullnode: networkData.rpcUrls.http[0],
    network: networkData.cluster as Network,
  });

  const aptosClient = new Aptos(config);

  const balance = await aptosClient.getBalance({
    accountAddress: address,
    // APT coin type
    asset: '0x1::aptos_coin::AptosCoin',
  });

  return (Number(balance) / OCTAS_PER_APT).toString();
};
